'use strict';

var parsers = require('../parsers.cjs');
var getSystemTimeZone = require('../utils/getSystemTimeZone.cjs');
var format = require('./format.cjs');

function formatDayOfWeekWithLocale({
  dayOfWeek,
  localesType,
  format: format$1
}) {
  const date = parsers.dayOfWeekToDate(dayOfWeek);
  return format({
    date,
    locale: localesType,
    presetName: format$1 === "EEEE" ? "weekday" : "weekday_short",
    timeZone: getSystemTimeZone()
  });
}

module.exports = formatDayOfWeekWithLocale;
//# sourceMappingURL=formatDayOfWeekWithLocale.cjs.map
